import { useState, useEffect } from 'react'
import { useAccount, useNetwork, useDisconnect } from 'wagmi'
import { useWeb3Modal } from '@web3modal/react'

import Ethereum from 'src/assets/logos/Ethereum.svg'
import { evmNetworksDataType } from 'src/util/networksData'
import { evmNetworkIds } from 'src/util/chainIds'

const ConnectEthWallet = ({ network, chain: initialChain }: { network: string; chain: string }) => {
  const [address, setAddress] = useState('')
  const { open } = useWeb3Modal()
  const { chain } = useNetwork()
  const { connector } = useAccount({
    onConnect({ address }) {
      if (address) {
        setAddress(address)
      }
    },
  })

  const { disconnect } = useDisconnect({
    onSuccess() {
      setAddress('')
    },
  })

  const switchChains = async (chainId: number) => {
    try {
      if (connector && connector.switchChain) {
        await connector.switchChain(chainId)
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (connector && connector.switchChain) {
      const chainId =
        evmNetworkIds[initialChain.toUpperCase() as keyof evmNetworksDataType][network]

      if (chainId !== chain?.id) {
        switchChains(chainId)
      }
    }
  }, [connector, initialChain, network])

  return (
    <div className="flex">
      {address ? (
        <button
          onClick={() => disconnect()}
          className="grid gap-3 rounded-lg border border-main-blue bg-white bg-opacity-5 p-4 text-white outline-0">
          <img src={Ethereum} alt="Ethereum" className="mx-auto h-6 w-32" />
          <span className="text-sm font-light">Disconnect Ethereum wallet</span>
        </button>
      ) : (
        <button
          onClick={() => open()}
          className="grid gap-3 rounded-lg border border-white border-opacity-20 bg-white bg-opacity-5 p-4 text-white outline-0">
          <img src={Ethereum} alt="Ethereum" className="mx-auto h-6 w-32" />
          <span className="text-sm font-light">Connect Ethereum wallet</span>
        </button>
      )}
    </div>
  )
}

export default ConnectEthWallet
